export default {
    loginkf: 'index.php?c=login&act=kefulist&datatype=json&shopid=', // 客服信息 - 登录注册部分使用
    logininfo: 'index.php?c=login&act=login&datatype=json&shopid=', // 登录其它信息
    login: 'index.php?c=login&act=ajaxcuslogin&datatype=json&shopid=', // 登录 i_account 账号  i_password密码
    identifyingcode: 'index.php?c=login&act=sendcusphonecode&datatype=json&shopid=', // 注册-发送验证码
    register: 'index.php?c=login&act=ajaxcusphonecode&datatype=json&shopid=', // 注册验证-手机号和验证码
    evpi: 'index.php?c=login&act=ajaxcusreg&datatype=json&shopid=', // 注册-完善信息
    result: 'index.php?c=login&act=onecustomer&datatype=json&shopid=', // 注册-审核状态
    findpassword: 'index.php?c=login&act=ajaxcusforgetpwd&datatype=json&shopid=', // 找回密码
    findidentifyingcode: 'index.php?c=login&act=sendcusforgetpwd&datatype=json&shopid=', // 找回密码发送验证码
    setpassword: 'index.php?c=login&act=ajaxcusmodifypwd&datatype=json&shopid=', // 设置密码
    frame: 'c=home&act=base', // 外框架数据
    switchsupplier: 'c=user&act=switchshop', // 切换供货商
    home: 'c=home&act=index', // 首页数据
    checkgoods: 'c=goods&act=checkgoods', // 商品列表检测点击进入详情或添加收藏时是否已失效
    goodsclassify: 'c=goods&act=goodscatlist', // 商品分类
    goodslist: 'c=goods&act=goodslist', // 商品列表 & 商品分页
    goodsdetail: 'c=goods&act=showgood', // 商品详情
    goodscollect: 'c=goods&act=togcolloctgoods', // 商品收藏
    goodscheck: 'c=goods&act=addcart', // 商品加入购物车检测
    historygoods: 'c=goods&act=historygoods', // 商品浏览记录
    interestinglist: 'c=goods&act=interestinglist', // 快速补货
    detgoodslist: 'c=goods&act=cartgoodslist', // 购物车 - 列表
    confirmorder: 'c=order&act=paydosub', // 购物车 - 订单信息
    submitorder: 'c=order&act=suborder', // 购物车 - 立即下单
    recharge: 'c=fund&act=paylistforacount', // 充值余额
    getpay: 'c=fund&act=paylistfororder', // 支付 - 获取信息
    sbumitpay: 'c=fund&act=pcpay', // 支付 - 提交支付
    payonlinestat: 'c=fund&act=checkpaystatus', // 支付 - 在线支付检测是否支付成功
    qrcodepay: 'index.php?c=fund&act=erweimake&datatype=json&shopid=', // 支付 - 获取支付二维码
    payuploadfile: 'index.php?c=fund&act=uploadfile&datatype=json&shopid=', // 支付 - 上传凭证
    paydeluploadfile: 'index.php?c=fund&act=uploadfile&datatype=json&shopid=', // 支付 - 删除上传凭证
    orderlist: 'c=order&act=pcorderlist', // 订货单列表
    orderdetail: 'c=order&act=orderdetail', // 订货单详情
    ordercanceljudge: 'c=order&act=checkunorder', // 订货单详情 - 取消订单判断是否可以取消
    ordercancel: 'c=order&act=unorder', // 订货单详情 - 取消订单
    orderdown: 'index.php?c=order&act=downorderexcel&datatype=json&shopid=', // 订货单详情 - 导出订货单表格
    payrecord: 'c=order&act=orderfundlist', // 订货单详情 - 付款记录
    loginsics: 'c=order&act=ordersustain', // 订货单详情 - 出库/发货/物流
    takeover: 'c=order&act=suregetgoods', // 订货单详情 - 出库/发货/物流 确认收货
    getreturngoods: 'c=order&act=rebackorder', // 订货单 - 申请退货获取信息
    applyreturngoods: 'c=order&act=rebackorderadd', // 订货单 - 申请退货提交
    upload: 'index.php?c=order&act=uploadorderfile&datatype=json&shopid=', // 上传图片/文件
    delupload: 'c=order&act=unorderfile&datatype=json&shopid=', // 删除上传图片/文件
    returnlist: 'c=order&act=pcrebackorderlist', // 退货 - 列表
    returndetails: 'c=order&act=rebackorderdet', // 退货 - 详情
    returncancel: 'c=order&act=cancelorder', // 退货 - 取消退货
    delivergoods: 'c=order&act=surerebackgoods', // 退货 - 确认发货
    delivergoodsrevise: 'c=order&act=editwuliu', // 退货 - 修改物流信息
    returnupload: 'index.php?c=order&act=rebackuploadorderfile&datatype=json&shopid=', // 退货 - 上传文件
    returndelupload: 'c=order&act=rebackunorderfile', // 退货 - 删除已上传文件
    promotion: 'c=home&act=goodscxlist', // 促销 - 商品促销
    reducegive: 'c=home&act=shopcxlist', // 促销 - 满减满送
    message: 'c=home&act=noticelist', // 消息通知 type 1 业务消息 2 公司通知公告 3 留言咨询
    messageread: 'c=home&act=setread', // 消息通知 标记为已读
    newsdetails: 'c=home&act=noticeinfo', // 公司通知公告详情
    delmessage: 'c=home&act=msgdel', // 清空留言
    addmessage: 'c=home&act=msgadd', // 添加留言
    help: 'c=home&act=helplist', // 帮助中心
    helpdetails: 'c=home&act=helpinfo', // 帮助中心详情
    contactservice: 'c=home&act=kefulist', // 联系客服
    accounts: 'c=user&act=index', // 我的帐号
    accountsrevise: 'c=user&act=updatecustomer', // 我的帐号 - 提交修改信息
    accountsverification: 'c=user&act=sendmodifypwd', // 我的帐号 - 获取验证码
    accountrevisepwd: 'c=user&act=modifypwd', // 我的帐号 - 提交修改密码
    address: 'c=user&act=addresslist', // 地址管理
    addressdefault: 'c=user&act=setaddressmain', // 地址管理 - 设为默认
    addressdel: 'c=user&act=deladdress', // 地址管理 - 删除地址
    addressadd: 'c=user&act=saveaddress', // 地址管理 - 新增&编辑
    mycoupon: 'c=user&act=juanlist', // 我的优惠券
    couponlist: 'c=home&act=juanrulelist', // 优惠券列表
    getcoupon: 'c=home&act=usergetjuan', // 领取优惠券
    payrecordcapital: 'c=home&act=orderpaylist', // 支付记录
    depositrecord: 'c=home&act=customercostlist', // 预存款收支明细
    statisticgoods: 'c=home&act=goodstj', // 统计 - 订货汇总
    statgoodsupload: 'index.php?c=home&act=goodstj&datatype=json&shopid=', // 订货汇总 - 下载表格
    statisticsorder: 'c=home&act=ordertj', // 统计 - 订单统计
    statorderupload: 'index.php?c=home&act=ordertj&datatype=json&shopid=', // 订单统计 - 下载表格
    statisticsclassify: 'c=home&act=goodscattj', // 统计 - 分类统计
    statclassifyupload: 'index.php?c=home&act=goodscattj&datatype=json&shopid=', // 分类统计 - 下载表格
    statisticsbrand: 'c=home&act=brandtj', // 统计 - 分类统计
    statbrandupload: 'index.php?c=home&act=brandtj&datatype=json&shopid=', // 分类统计 - 下载表格
    getprovince: 'c=area&act=proLst', // 省
    getcity: 'c=area&act=cityLst', // 市
    getarea: 'c=area&act=areaLst', // 区/县
}


// WEBPACK FOOTER //
// ./src/request/api.js